export interface CreativeItemModel {
  id: string;
  convertStatus: string;
  type: string;
  dspName: string;
  externalId: string;
  formatName: string;
  height: number;
  width: number;
  rotation: number;
  statusCode: string;
  thumbnail: string;
  updated: number;
  updatedBy: string;
}

export const TARGET = {
  SELF: '_self',
  BLANK: '_blank',
} as const;

export interface ImageRendererProps {
  data: CreativeItemModel;
  target?: (typeof TARGET)[keyof typeof TARGET];
  hoverIcon?: React.ReactNode;
  link?: string;
  isExternalLink?: boolean;
}
